export class GoogleAnalytics4Actions {
    static readonly purchase = 'purchase';
    static readonly refund = 'refund';
    static readonly addPaymentInfo = 'add_payment_info';
    static readonly addShippingInfo = 'add_shipping_info';
    static readonly beginCheckout = 'begin_checkout';
    static readonly addToCart = 'add_to_cart';
    static readonly addToWishList = 'add_to_wishlist';
    static readonly removeFromCart = 'remove_from_cart';
    static readonly viewCart = 'view_cart';
    static readonly viewMiniCart = 'view_mini_cart';
    static readonly viewItem = 'view_item';
    static readonly selectItem = 'select_item';
    static readonly viewItemList = 'view_item_list';
    static readonly viewPromotion = 'view_promotion';
    static readonly selectPromotion = 'select_promotion';
    static readonly searchSuggestions = 'search_suggestions';
    static readonly viewSearchResults = 'view_search_results';
    static readonly applySearchTagClick = 'apply_search_tag_click';
}
